import type { EmailAutomation } from '../../types/automazioni.types';

/**
 * Le sequenze accese che partono quando qualcuno entra in questa lista.
 *
 * Servono a dirlo prima: aggiungere un contatto alla lista lo fa entrare
 * nella sequenza, e se puo' ricevere gli arrivano le sue email. Le sequenze
 * in bozza o in pausa non contano, perche' non fanno partire niente.
 */
export function sequenzeCheParteDa(
  automazioni: readonly EmailAutomation[],
  listaId: string
): EmailAutomation[] {
  return automazioni.filter(
    (a) =>
      a.status === 'attiva' &&
      a.trigger_kind === 'etichetta_aggiunta' &&
      a.trigger_config?.tag_id === listaId
  );
}
